<template>
    <console-layout width="100%" max-width="1280">
        <console-title>
            <span>1:1 문의</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row class="mt-2">
                <v-col cols="12" sm="3" class="py-0">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3" class="py-0">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-end mt-2">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span v-if="$hasScope(['root', 'admin'])">
                    <v-btn color="white" elevation="1" class="red--text px-2 ml-1" @click="removeSelected">선택 삭제</v-btn>
                </span>
            </v-layout>

            <v-data-table v-model="selected" :items="questions" :headers="questionsHeaders" item-key="_id" :show-select="$hasScope(['root', 'admin'])" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template #[`item.no`]="{item}">{{ (page - 1) * limit + +questions.indexOf(item) + 1 }}</template>
                <template #[`item.member`]="{item}">
                    <div v-if="item.member">
                        <div>{{ item?.member?.name }}</div>
                        <div>{{ item?.member?.phone }}</div>
                        <div>{{ item?.member?.email }}</div>
                    </div>
                    <span v-else>탈퇴회원</span>
                </template>
                <template #[`item.answer`]="{item}">
                    <span v-if="item.answer">답변</span>
                    <span v-else>미답변</span>
                </template>
                <template #[`item.createdAt`]="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template #[`item.actions`]="{item}">
                    <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon v-if="$hasScope(['root', 'admin'])" small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>
        </console-body>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            selected: [],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            questions: [],
            questionsHeaders: [
                { text: "no", value: "no", align: "center", width: 100 },
                { text: "제목", value: "subject", align: "center" },
                { text: "작성자", value: "member", align: "center", width: 180 },
                { text: "답변여부", value: "answer", align: "center", width: 100 },
                { text: "작성일자", value: "createdAt", align: "center", width: 180 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제목", value: "subject" },
                { text: "내용", value: "content" },
                { text: "작성자", value: "name" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, questions } = await api.console.center.questions.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.questions = questions;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.selected = [];
        },
        edit(question){
            this.$router.push(`/console/center/questions/${question._id}`);
        },
        // 실패 메시지는 axios 플러그인이 403 응답을 alert 로 띄운다
        async remove(question){
            if(!confirm("삭제한 문의는 고객 화면과 관리자 화면 모두에서 보이지 않습니다. 계속할까요?")) return;
            try {
                await api.console.center.questions.delete(question);
                alert("삭제되었습니다");
            } catch(error) {}
            await this.search();
        },
        async removeSelected(){
            if(!this.selected.length) return alert("삭제할 문의를 선택해주세요");
            if(!confirm(`선택한 ${this.selected.length}건을 삭제합니다.\n삭제한 문의는 고객 화면과 관리자 화면 모두에서 보이지 않습니다. 계속할까요?`)) return;
            try {
                let { summary } = await api.console.center.questions.deleteMany(this.selected.map(({ _id }) => _id));
                alert(summary.skippedCount ? `${summary.deletedCount}건 삭제되었습니다 (이미 삭제됐거나 없는 문의 ${summary.skippedCount}건 제외)` : `${summary.deletedCount}건 삭제되었습니다`);
            } catch(error) {}
            await this.search();
        },
        // async excel(){
        //     let { questions } = await api.console.center.questions.gets({ headers: { limit: 0 }, params: this.filter });

        //     let rows = [];
        //     questions.forEach(question => {
        //         rows.push({
        //             "no": question.no,
        //             "이름": question.name,
        //         });
        //     });

        //     let workbook = new XLSX.utils.book_new();
        //     let worksheet = XLSX.utils.json_to_sheet(rows);

        //     XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
        //     XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        // }
    }
}
</script>